module.exports = __webpack_public_path__ + "static/img/Steph-Catley.232da41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steph-Catley.jpg
// module id = uJuW
// module chunks = 0